import { ExportOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

/**
 * @description detay sayfasindaki madde ismi ve maddenin hangi kaynaktan geldigini
 * goruntulemek icin kullanilir
 * @param {string} articleSource
 * @param {string} articleTitle
 * @param {string} [resourceUrl] - Maddenin kaynak URL'i. Varsa başlığın yanında external link iconu gösterilir.
 * @param {boolean} [isAbandoned=false] - Madde terk edilmişse "Terk" badge'i gösterilir.
 * */
function PageTitle({ articleSource, articleTitle, resourceUrl, isAbandoned = false }) {
  return (
    <div>
      <Tag
        style={{
          borderRadius: 25,
          padding: '5px 15px',
          fontSize: 14,
          textTransform: 'uppercase',
        }}
        className="gx-mb-3 gx-mt-5"
      >
        {articleSource}
      </Tag>
      <div className="gx-d-flex gx-align-items-center" style={{ gap: 8 }}>
        <h2 className="gx-h1-lg gx-mb-0">{articleTitle}</h2>
        {resourceUrl && (
          <a href={resourceUrl} target="_blank" rel="noopener noreferrer">
            <ExportOutlined style={{ fontSize: 20, color: '#1890ff' }} />
          </a>
        )}
        {isAbandoned && <Tag color="blue">Terk</Tag>}
      </div>
    </div>
  );
}

export default PageTitle;
